/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import Pending_fill from "../../assets/Image/Pending_fill.png";
import processing_grey from "../../assets/Image/processing_grey.png";
import processing_fill from "../../assets/Image/Processing_fill.png";
import route_grey from "../../assets/Image/route_grey.png";
import route_fill from "../../assets/Image/route-fill.png";
import cancel from "../../assets/Image/cancel.png";
import complete_fill from "../../assets/Image/complete_fill.png";
import complete_grey from "../../assets/Image/complete_grey.png";
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import { LuChevronRight, LuMapPin, LuCreditCard, LuPackage } from 'react-icons/lu';
import { IoChevronBackOutline } from 'react-icons/io5';

const OrderDetails = () => {

    const { t } = useTranslation();
    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);
    const navigate = useNavigate();

    const [isInfo, setIsInfo] = useState();
    const [productList, setProductList] = useState([]);
    const [isShowPhoto, setIsShowPhoto] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const [lightBox, setLightBox] = useState([]);
    const [lightBoxIndex, setLightBoxIndex] = useState("");

    const Location = useLocation();
    const OrderId = Location.state;

    const Userid = secureLocalStorage.getItem("Userid");
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    useEffect(() => {
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/product_order_detail`, { uid: Userid, order_id: OrderId.id })
                .then((res) => {
                    // console.log("product_order_detail", res);
                    setLoading(false);
                    setIsInfo(res.data.order_detail);
                    setProductList(res.data.product_list);
                    const product = res.data.product_list;
                    for (let i = 0; i < product?.length; i++) {
                        if (product[i].prescription_require === "Required") {
                            setIsShowPhoto(true);
                        }
                    }
                    const Data = [];
                    const Object = res.data.order_detail.medicine_prescription;
                    for (let i = 0; i < Object.length; i++) {
                        Data.push({ src: ImgBaseUrl + Object[i] });
                    }
                    setLightBox(Data);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, []);

    return (
        <div className="order-details-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
            {loading ? (
                <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" index={0} />
            ) : (
                <div className="flex flex-col">
                    {/* Header Navigation */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
                        <button
                            onClick={() => window.history.back()}
                            className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
                        >
                            <IoChevronBackOutline className="w-4 h-4" />
                            <span className="font-medium text-sm">{t("Go Back")}</span>
                        </button>

                        <div className="flex items-center gap-2 text-sm text-slate-500">
                            <span className="hover:text-indigo-650 font-medium transition-colors cursor-pointer" onClick={() => navigate("/dashbord")}>{t("Dashboard")}</span>
                            <LuChevronRight className="w-3.5 h-3.5" />
                            <span className="hover:text-indigo-650 font-medium transition-colors cursor-pointer" onClick={() => window.history.back()}>{t("My Orders")}</span>
                            <LuChevronRight className="w-3.5 h-3.5" />
                            <span className="font-semibold text-slate-800">{t("Order Details")}</span>
                        </div>
                    </div>

                    {/* Order ID Header */}
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-10 h-10 bg-indigo-50 border border-indigo-100 rounded-2xl flex items-center justify-center shrink-0">
                            <LuPackage className="w-5 h-5 text-indigo-600" />
                        </div>
                        <div>
                            <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">{t("Order ID")}</span>
                            <h2 className="font-black text-slate-800 text-xl">#{OrderId.id}</h2>
                        </div>
                    </div>

                    {/* Main Content Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                        {/* Left Column - Products & Prescription */}
                        <div className="lg:col-span-2 flex flex-col gap-6">

                            {/* Order Status Stepper */}
                            <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                                <h3 className="font-bold text-slate-800 text-lg mb-5">{t("Order Status")}</h3>
                                <div className="flex items-center justify-between gap-2">

                                    {/* Pending */}
                                    <div className="flex flex-col items-center gap-1.5 text-center">
                                        <div className="w-14 h-14 rounded-2xl bg-indigo-50 border border-indigo-100 flex items-center justify-center shadow-sm">
                                            <img src={Pending_fill} alt="Pending" className="w-8 h-8 object-contain" />
                                        </div>
                                        <span className="text-xs font-bold text-indigo-600">{t("Pending")}</span>
                                    </div>

                                    <div className={`flex-1 h-0.5 rounded-full ${isInfo?.status < "1" ? "bg-slate-200" : "bg-indigo-400"}`}></div>

                                    {/* Processing */}
                                    <div className="flex flex-col items-center gap-1.5 text-center">
                                        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm border ${(isInfo?.status < "1" || isInfo?.status === "4") ? "bg-slate-50 border-slate-150" : "bg-indigo-50 border-indigo-100"}`}>
                                            <img src={(isInfo?.status < "1" || isInfo?.status === "4") ? processing_grey : processing_fill} alt="Processing" className="w-8 h-8 object-contain" />
                                        </div>
                                        <span className={`text-xs font-bold ${(isInfo?.status < "1" || isInfo?.status === "4") ? "text-slate-400" : "text-indigo-600"}`}>{t("Processing")}</span>
                                    </div>

                                    <div className={`flex-1 h-0.5 rounded-full ${(isInfo?.status < "2" || isInfo?.status === "4") ? "bg-slate-200" : "bg-indigo-400"}`}></div>

                                    {/* On Route */}
                                    <div className="flex flex-col items-center gap-1.5 text-center">
                                        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm border ${(isInfo?.status < "2" || isInfo?.status === "4") ? "bg-slate-50 border-slate-150" : "bg-indigo-50 border-indigo-100"}`}>
                                            <img src={(isInfo?.status < "2" || isInfo?.status === "4") ? route_grey : route_fill} alt="On Route" className="w-8 h-8 object-contain" />
                                        </div>
                                        <span className={`text-xs font-bold ${(isInfo?.status < "2" || isInfo?.status === "4") ? "text-slate-400" : "text-indigo-600"}`}>{t("On Route")}</span>
                                    </div>

                                    <div className={`flex-1 h-0.5 rounded-full ${isInfo?.status < "3" ? "bg-slate-200" : isInfo?.status === "4" ? "bg-rose-300" : "bg-emerald-400"}`}></div>

                                    {/* Delivered / Cancelled */}
                                    <div className="flex flex-col items-center gap-1.5 text-center">
                                        <div className={`w-14 h-14 rounded-2xl flex items-center justify-center shadow-sm border ${
                                            isInfo?.status < "3"
                                                ? "bg-slate-50 border-slate-150"
                                                : isInfo?.status === "4"
                                                    ? "bg-rose-50 border-rose-100"
                                                    : "bg-emerald-50 border-emerald-100"
                                        }`}>
                                            <img
                                                src={isInfo?.status < "3" ? complete_grey : isInfo?.status === "4" ? cancel : complete_fill}
                                                alt="Deliver"
                                                className="w-8 h-8 object-contain"
                                            />
                                        </div>
                                        <span className={`text-xs font-bold ${
                                            isInfo?.status < "3"
                                                ? "text-slate-400"
                                                : isInfo?.status === "4"
                                                    ? "text-rose-600"
                                                    : "text-emerald-600"
                                        }`}>
                                            {isInfo?.status === "4" ? t("Cancelled") : t("Delivered")}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Product List */}
                            <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                                <h3 className="font-bold text-slate-800 text-lg">{t("Order Items")}</h3>
                                <div className="flex flex-col divide-y divide-slate-100">
                                    {productList?.map((item, index) => (
                                        <div key={index} className="flex items-start gap-4 py-4 first:pt-0 last:pb-0">
                                            {/* Large Product Image */}
                                            <div className="w-24 h-24 rounded-2xl overflow-hidden border border-slate-150 shrink-0 shadow-inner bg-slate-50">
                                                <ImageLoad
                                                    src={ImgBaseUrl + item.product_image}
                                                    CustomeStyle="w-full h-full object-cover"
                                                    alt="product_image"
                                                />
                                            </div>

                                            {/* Product Info */}
                                            <div className="flex-1 min-w-0">
                                                {item.prescription_require === "Required" && (
                                                    <span className="inline-block text-[10px] font-bold uppercase tracking-wider bg-rose-50 border border-rose-100 text-rose-600 px-2.5 py-0.5 rounded-full mb-1.5">
                                                        {t("Prescription Required")}
                                                    </span>
                                                )}
                                                <h4 className="font-bold text-slate-800 text-base line-clamp-1">{item.product_name}</h4>
                                                <p className="text-slate-400 text-xs font-medium mt-0.5">{item.price_detail.title}</p>

                                                <div className="flex flex-wrap items-center gap-2 mt-2">
                                                    <span className="font-black text-slate-800 text-base">{currency}{item.price_detail.price}</span>
                                                    <span className="line-through text-slate-400 text-sm">{currency}{item.price_detail.bprice}</span>
                                                    <span className="bg-orange-50 border border-orange-100 text-orange-600 text-[10px] font-bold px-2 py-0.5 rounded-full">
                                                        {item.price_detail.discount}% {t("OFF")}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Qty & Type */}
                                            <div className="flex flex-col items-end text-right shrink-0">
                                                <span className="text-slate-400 text-xs font-medium">{item.pro_type}</span>
                                                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mt-2">{t("Qty")}</span>
                                                <span className="font-black text-slate-800 text-lg">{item.price_detail.qty}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Medicine Prescription Photos */}
                            {isShowPhoto && isInfo?.medicine_prescription?.length > 0 && (
                                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                                    <h3 className="font-bold text-slate-800 text-lg">{t("Medicine Prescription")}</h3>
                                    <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
                                        {isInfo.medicine_prescription.map((item, index) => (
                                            <div
                                                key={index}
                                                onClick={() => { setIsShow(true); setLightBoxIndex(index); }}
                                                className="relative aspect-square rounded-2xl overflow-hidden border border-slate-150 cursor-pointer shadow-inner bg-slate-50 hover:border-indigo-300 hover:shadow-md transition-all duration-200 group"
                                            >
                                                <ImageLoad
                                                    src={ImgBaseUrl + item}
                                                    CustomeStyle="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                                    alt="prescription"
                                                />
                                                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/10 transition-all duration-200 flex items-center justify-center">
                                                    <span className="text-white text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-slate-900/60 px-2 py-1 rounded-lg">{t("View")}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Right Column - Billing & Address */}
                        <div className="flex flex-col gap-6">

                            {/* Payment & Address Info */}
                            <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                                <div className="flex items-center gap-2">
                                    <LuCreditCard className="w-5 h-5 text-indigo-600 shrink-0" />
                                    <h3 className="font-bold text-slate-800 text-lg">{t("Bill Summary")}</h3>
                                </div>

                                <div className="flex flex-col gap-3 mt-1">
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="text-slate-500 font-medium">{t("Product Amount")}</span>
                                        <span className="font-bold text-slate-700">{currency} {isInfo?.sitter_amount}</span>
                                    </div>

                                    <div className="flex items-center justify-between text-sm">
                                        <span className="text-slate-500 font-medium">{t("Site Commission")}</span>
                                        <span className="font-bold text-slate-700">{currency} {isInfo?.site_commission}</span>
                                    </div>

                                    {isInfo?.coupon_amount !== 0 && (
                                        <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                                            <span>{t("Coupon Discount")}</span>
                                            <span>-{currency} {isInfo?.coupon_amount}</span>
                                        </div>
                                    )}

                                    {isInfo?.wallet !== 0 && (
                                        <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                                            <span>{t("Wallet Payment")}</span>
                                            <span>-{currency} {isInfo?.wallet}</span>
                                        </div>
                                    )}

                                    <div className="border-t border-slate-100 border-dashed my-1"></div>

                                    <div className="flex items-center justify-between">
                                        <span className="font-black text-slate-800 text-[15px]">{t("Total Price")}</span>
                                        <span className="font-black text-indigo-600 text-lg">{currency} {isInfo?.tot_price}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Payment Method */}
                            <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-3">
                                <h3 className="font-bold text-slate-800 text-lg">{t("Payment Details")}</h3>

                                <div className="flex flex-col gap-2.5 mt-1">
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="text-slate-500 font-medium">{t("Payment Method")}</span>
                                        <span className="font-bold text-slate-700">
                                            {isInfo?.wallet !== 0 ? `Wallet & ${isInfo?.payment_name}` : isInfo?.payment_name}
                                        </span>
                                    </div>

                                    {isInfo?.wallet !== 0 && (
                                        <div className="flex items-center justify-between text-sm">
                                            <span className="text-slate-500 font-medium">{t("Paid from Wallet")}</span>
                                            <span className="font-bold text-slate-700">{currency} {isInfo?.wallet}.00</span>
                                        </div>
                                    )}

                                    {isInfo?.online_amount !== 0 && (
                                        <div className="flex items-center justify-between text-sm">
                                            <span className="text-slate-500 font-medium">{t("Online Paid")}</span>
                                            <span className="font-bold text-slate-700">{currency} {isInfo?.online_amount}.00</span>
                                        </div>
                                    )}

                                    {isInfo?.transactionId && (
                                        <div className="mt-1 text-[11px] font-semibold text-slate-400 leading-tight">
                                            {t("Transaction ID")}: <span className="text-slate-500 font-mono">{isInfo?.transactionId}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Delivery Address */}
                            <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-3">
                                <div className="flex items-center gap-2">
                                    <LuMapPin className="w-5 h-5 text-indigo-600 shrink-0" />
                                    <h3 className="font-bold text-slate-800 text-lg">{t("Delivery Address")}</h3>
                                </div>
                                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4">
                                    <p className="text-slate-600 text-sm font-medium leading-relaxed">
                                        {isInfo?.house_no}, {isInfo?.address}
                                        {isInfo?.landmark && `, ${isInfo?.landmark}`}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            <Lightbox
                open={isShow}
                close={() => setIsShow(false)}
                slides={lightBox}
                index={lightBoxIndex}
                plugins={[Zoom]}
            />
        </div>
    );
}

export default OrderDetails;
/* jshint ignore:end */